export default __webpack_public_path__ + "banner-frameworkc329d5.png";